/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { catchErrorAsJson } from '@fcom/rx';
import { DapiHttpResponse } from '../../dapi-http-response';
import { DapiRequestBuilder } from '../../dapi-request-builder';

import { FareRuleCategory } from '../../models/fare-rule-category';
import { FareRules } from '../../models/fare-rules';

export interface GetFareRulesByCart$Params {
  cartId: string;
  travelerId: string;
  ruleCategory: FareRuleCategory;
  hash?: string;
}

export function getFareRulesByCart(http: HttpClient, rootUrl: string, params: GetFareRulesByCart$Params, context?: HttpContext): Observable<DapiHttpResponse<FareRules>> {
  const rb = new DapiRequestBuilder(rootUrl, getFareRulesByCart.PATH, 'get');

  if (params) {
    rb.path('cartId', params.cartId, {});
    rb.query('travelerId', params.travelerId, {});
    rb.query('ruleCategory', params.ruleCategory, {});
    rb.query('hash', params.hash, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as DapiHttpResponse<FareRules>;
    }),
    catchErrorAsJson()
  );
}

getFareRulesByCart.PATH = '/api/v2/cart/{cartId}/rules';
